import { createFileRoute } from "@tanstack/react-router";
import { PackAdminPage } from "@client/components/settings/industry-pack/pack-admin-page";

export const Route = createFileRoute("/_app/settings/industry-packs/")({
  component: PackAdminPage,
});
